import {Box} from "@mui/material";
import {SurveyInvitationStatus} from "crqlar-react-common/dist/models/survey/surveyInvitation.model";
import {useTranslation} from "react-i18next";
import {ElementChip} from "../../common/uiElements/base/ElementChip";

const SURVEY_INVITATION_STATUS_LABEL_KEYS: Record<SurveyInvitationStatus, string> = {
    [SurveyInvitationStatus.NOT_OPENED]: 'Invitation status NOT_OPENED',
    [SurveyInvitationStatus.OPENED]: 'Invitation status OPENED',
    [SurveyInvitationStatus.IN_PROGRESS]: 'Invitation status IN_PROGRESS',
    [SurveyInvitationStatus.COMPLETED]: 'Invitation status COMPLETED',
    [SurveyInvitationStatus.VOIDED]: 'Invitation status VOIDED',
};

const SURVEY_INVITATION_STATUS_COLORS: Record<SurveyInvitationStatus, string> = {
    [SurveyInvitationStatus.NOT_OPENED]: 'text.secondary',
    [SurveyInvitationStatus.OPENED]: 'info.main',
    [SurveyInvitationStatus.IN_PROGRESS]: 'info.main',
    [SurveyInvitationStatus.COMPLETED]: 'success.main',
    [SurveyInvitationStatus.VOIDED]: 'action.disabled',
};

interface Props {
    status: SurveyInvitationStatus | undefined;
    furthestQuestionIndex?: number;
    asPrint?: boolean;
}

const SurveyInvitationStatusChip = ({status, furthestQuestionIndex, asPrint = false}: Props) => {
    const {t} = useTranslation();

    const effectiveStatus = status ?? SurveyInvitationStatus.NOT_OPENED;

    const text = effectiveStatus === SurveyInvitationStatus.IN_PROGRESS && furthestQuestionIndex !== undefined
        ? t('Invitation status IN_PROGRESS · Q{{n}}', {n: furthestQuestionIndex + 1})
        : t(SURVEY_INVITATION_STATUS_LABEL_KEYS[effectiveStatus] ?? effectiveStatus);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: 'inline-flex', maxWidth: '100%'}}>
            <ElementChip
                text={text}
                startIcon={
                    <Box
                        component={'span'}
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: SURVEY_INVITATION_STATUS_COLORS[effectiveStatus],
                            flex: '0 0 auto',
                        }}
                    />
                }
            />
        </Box>
    );
};

export default SurveyInvitationStatusChip;
